import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { DatePipe } from '@angular/common';

@Injectable()
export class RickService {

  constructor(private httpClient: HttpClient, private datepipe: DatePipe) { }

  getCustomerById(customerId: any, state: any, store: any, lot: any) {
    let apiUrl = '/api/v1/rick/modelmaster/' + customerId + '/' + state + '/' + store + '/' + lot;
    return this.httpClient.get(apiUrl)
      .pipe(tap((result: any) => {
      }));
  }

  addCustomerData(data: any) {
    return this.httpClient.post('/api/v1/rick/modelmaster', data)
      .pipe(tap((result: any) => {
      }));
  }

  updateCustomerData(data: any) {
    return this.httpClient.put('/api/v1/rick/modelmaster', data)
      .pipe(tap((result: any) => {
      }));
  }

  addCasesUsed(data: any) {
    return this.httpClient.post('/api/v1/rick/casesused', data)
      .pipe(tap((result: any) => {
      }));
  }

  fetchLotsByEDP(customerId: any, state: any, store: any) {
    let apiUrl = '/api/v1/rick/piecesused/getAllLotNumbers?customer=' + customerId + '&state=' + state + '&store=' + store;
    return this.httpClient.get(apiUrl)
      .pipe(tap((result: any) => {
      }));
  }

  updatePiecesUsed(data: any) {
    return this.httpClient.post('/api/v1/rick/piecesused', data)
      .pipe(tap((result: any) => {
      }));
  }

  fetchLotsByEDPInventoryAdj(customerId: any, state: any, store: any) {
    let apiUrl = '/api/v1/rick/invmaster/getAllLotNumbers?customer=' + customerId + '&state=' + state + '&store=' + store;
    return this.httpClient.get(apiUrl)
      .pipe(tap((result: any) => {
      }));
  }

  updateInventoryAdj(data: any) {
    return this.httpClient.post('/api/v1/rick/invmaster', data)
      .pipe(tap((result: any) => {
      }));
  }
}
